
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter1On as ObiFilter1OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-1-on.js';
 
 
 

 
 export const ObiFilter1On = createComponent({
   react: React,
   tagName: 'obi-filter-1-on',
   elementClass: ObiFilter1OnElement,
   events: {
     
   }
  });
 
 